// NOTE: BE 공통 인증 실패 에러 코드 (모든 도메인 공유)
// COMMON-001-005: 실제 응답, UNAUTHORIZED: wiki 스펙 — 둘 다 커버
export const ERROR_CODE_COMMON_UNAUTHORIZED = 'COMMON-001-005';
export const ERROR_CODE_UNAUTHORIZED = 'UNAUTHORIZED';

export const isUnauthorizedErrorCode = (errorCode: string | undefined): boolean =>
  errorCode === ERROR_CODE_COMMON_UNAUTHORIZED || errorCode === ERROR_CODE_UNAUTHORIZED;

// NOTE: API 에러 타입 정의 및 type guard
export interface ApiError {
  data: {
    data: null;
    meta: {
      errorCode?: string;
      message: string;
    };
  };
  status: number;
  message: string;
}

export const isApiError = (error: unknown): error is ApiError =>
  error !== null &&
  typeof error === 'object' &&
  'data' in error &&
  error.data !== null &&
  typeof error.data === 'object' &&
  'meta' in error.data &&
  error.data.meta !== null &&
  typeof error.data.meta === 'object' &&
  'message' in error.data.meta &&
  typeof error.data.meta.message === 'string';
